module.exports = __webpack_public_path__ + "img/a4.f4200c05.png";